import { render, staticRenderFns } from "./AllTabsDeposit.vue?vue&type=template&id=3f253a5a"
import script from "./AllTabsDeposit.vue?vue&type=script&lang=js"
export * from "./AllTabsDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports